export default __webpack_public_path__ + "static/media/contact-us.5fbbd31f.svg";